export enum ClientType {
  PHYSICAL_PERSON = '01',
  LEGAL_PERSON = '03',
}

export enum ClientTypeLabel {
  PHYSICAL_PERSON = 'particulier',
  LEGAL_PERSON = 'professionnel',
}
